import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function RegistrationPage() {
  const { t } = useTranslation();

  const fadeInUp = {
    initial: { opacity: 0, y: 40 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 },
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen">
        <main className="pt-20">
          {/* Hero Section */}
          <section className="bg-gradient-to-br from-primary to-primary-dark py-32 text-white">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
              <motion.h1
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                className="font-futura font-black text-5xl sm:text-6xl md:text-7xl mb-6"
              >
                {t('registration:hero.title')}
              </motion.h1>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                className="text-xl sm:text-2xl text-white/90"
              >
                {t('registration:hero.subtitle')}
              </motion.p>
            </div>
          </section>

          {/* Pricing Section */}
          <section className="py-24 bg-white">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
              <motion.h2
                {...fadeInUp}
                className="font-futura font-black text-4xl sm:text-5xl text-primary text-center mb-16"
              >
                {t('registration:pricing.title')}
              </motion.h2>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                {/* Skyrace Pricing */}
                <motion.div
                  {...fadeInUp}
                  transition={{ delay: 0.1 }}
                  className="bg-gradient-to-br from-white to-gray-50 border-2 border-primary rounded-2xl p-8 shadow-lg"
                >
                  <h3 className="font-futura font-black text-2xl text-primary mb-8">
                    {t('registration:pricing.skyrace')}
                  </h3>

                  {/* Early */}
                  <div className="mb-6 pb-6 border-b border-gray-200">
                    <div className="flex items-center justify-between mb-2">
                      <div>
                        <p className="font-futura font-bold text-lg text-gray-900">
                          {t('registration:pricing.early.title')}
                        </p>
                        <p className="text-sm text-gray-600">{t('registration:pricing.early.deadline')}</p>
                      </div>
                      <div className="text-center">
                        <p className="font-futura font-black text-5xl text-primary">30€</p>
                      </div>
                    </div>
                    <span className="inline-block bg-primary text-white text-xs font-bold px-3 py-1 rounded-full">
                      {t('registration:pricing.early.badge')}
                    </span>
                  </div>

                  {/* Standard */}
                  <div className="mb-6 pb-6 border-b border-gray-200">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="font-futura font-bold text-lg text-gray-900">
                          {t('registration:pricing.standard.title')}
                        </p>
                        <p className="text-sm text-gray-600">{t('registration:pricing.standard.deadline')}</p>
                      </div>
                      <div className="text-center">
                        <p className="font-futura font-black text-4xl text-gray-900">40€</p>
                      </div>
                    </div>
                  </div>

                  {/* Late */}
                  <div className="mb-8">
                    <div className="flex items-center justify-between mb-2">
                      <div>
                        <p className="font-futura font-bold text-lg text-gray-900">
                          {t('registration:pricing.late.title')}
                        </p>
                        <p className="text-sm text-gray-600">{t('registration:pricing.late.deadline')}</p>
                      </div>
                      <div className="text-center">
                        <p className="font-futura font-black text-4xl text-gray-700">50€</p>
                      </div>
                    </div>
                    <span className="inline-block bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                      {t('registration:pricing.late.badge')}
                    </span>
                  </div>

                  <a
                    href="https://www.avaibooksports.com/inscripcion/sinjavina-skyrace/inscripcion_datos/?cod_cuota=89693"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full bg-primary hover:bg-primary-dark text-white font-futura font-bold text-center py-4 rounded-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
                  >
                    {t('registration:pricing.buttonSkyrace')}
                  </a>
                </motion.div>

                {/* Mini Skyrace Pricing */}
                <motion.div
                  {...fadeInUp}
                  transition={{ delay: 0.2 }}
                  className="bg-gradient-to-br from-white to-gray-50 border-2 border-primary rounded-2xl p-8 shadow-lg"
                >
                  <h3 className="font-futura font-black text-2xl text-primary mb-8">
                    {t('registration:pricing.miniSkyrace')}
                  </h3>

                  {/* Early */}
                  <div className="mb-6 pb-6 border-b border-gray-200">
                    <div className="flex items-center justify-between mb-2">
                      <div>
                        <p className="font-futura font-bold text-lg text-gray-900">
                          {t('registration:pricing.early.title')}
                        </p>
                        <p className="text-sm text-gray-600">{t('registration:pricing.early.deadline')}</p>
                      </div>
                      <div className="text-center">
                        <p className="font-futura font-black text-5xl text-primary">15€</p>
                      </div>
                    </div>
                    <span className="inline-block bg-primary text-white text-xs font-bold px-3 py-1 rounded-full">
                      {t('registration:pricing.early.badge')}
                    </span>
                  </div>

                  {/* Standard */}
                  <div className="mb-6 pb-6 border-b border-gray-200">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="font-futura font-bold text-lg text-gray-900">
                          {t('registration:pricing.standard.title')}
                        </p>
                        <p className="text-sm text-gray-600">{t('registration:pricing.standard.deadline')}</p>
                      </div>
                      <div className="text-center">
                        <p className="font-futura font-black text-4xl text-gray-900">20€</p>
                      </div>
                    </div>
                  </div>

                  {/* Late */}
                  <div className="mb-8">
                    <div className="flex items-center justify-between mb-2">
                      <div>
                        <p className="font-futura font-bold text-lg text-gray-900">
                          {t('registration:pricing.late.title')}
                        </p>
                        <p className="text-sm text-gray-600">{t('registration:pricing.late.deadline')}</p>
                      </div>
                      <div className="text-center">
                        <p className="font-futura font-black text-4xl text-gray-700">25€</p>
                      </div>
                    </div>
                    <span className="inline-block bg-orange-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                      {t('registration:pricing.late.badge')}
                    </span>
                  </div>

                  <a
                    href="https://www.avaibooksports.com/inscripcion/sinjavina-skyrace/inscripcion_datos/?cod_cuota=89694"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full bg-primary hover:bg-primary-dark text-white font-futura font-bold text-center py-4 rounded-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
                  >
                    {t('registration:pricing.buttonMini')}
                  </a>
                </motion.div>
              </div>
            </div>
          </section>

          {/* Timeline Section */}
          <section className="py-24 bg-gray-50">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
              <motion.h2
                {...fadeInUp}
                className="font-futura font-black text-4xl sm:text-5xl text-primary text-center mb-16"
              >
                {t('registration:dates.title')}
              </motion.h2>

              <div className="relative">
                {/* Timeline Line */}
                <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-primary hidden md:block"></div>

                {/* Timeline Items */}
                <div className="space-y-12">
                  {/* March 1 */}
                  <motion.div {...fadeInUp} className="relative">
                    <div className="md:flex md:items-center">
                      <div className="md:w-1/2 md:pr-12 md:text-right mb-4 md:mb-0">
                        <h3 className="font-futura font-black text-2xl text-gray-900 mb-2">
                          {t('registration:dates.march1.date')}
                        </h3>
                        <p className="font-futura font-bold text-lg text-primary mb-1">
                          {t('registration:dates.march1.event')}
                        </p>
                        <p className="text-gray-600">{t('registration:dates.march1.detail')}</p>
                      </div>
                      <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-10 h-10 bg-primary rounded-full border-4 border-white shadow-lg"></div>
                      <div className="md:w-1/2 md:pl-12"></div>
                    </div>
                  </motion.div>

                  {/* April 30 */}
                  <motion.div {...fadeInUp} transition={{ delay: 0.1 }}>
                    <div className="md:flex md:items-center">
                      <div className="md:w-1/2 md:pr-12"></div>
                      <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-10 h-10 bg-primary rounded-full border-4 border-white shadow-lg"></div>
                      <div className="md:w-1/2 md:pl-12">
                        <h3 className="font-futura font-black text-2xl text-gray-900 mb-2">
                          {t('registration:dates.april30.date')}
                        </h3>
                        <p className="font-futura font-bold text-lg text-primary mb-1">
                          {t('registration:dates.april30.event')}
                        </p>
                        <p className="text-gray-600">{t('registration:dates.april30.detail')}</p>
                      </div>
                    </div>
                  </motion.div>

                  {/* May 15 */}
                  <motion.div {...fadeInUp} transition={{ delay: 0.2 }}>
                    <div className="md:flex md:items-center">
                      <div className="md:w-1/2 md:pr-12 md:text-right mb-4 md:mb-0">
                        <h3 className="font-futura font-black text-2xl text-gray-900 mb-2">
                          {t('registration:dates.may15.date')}
                        </h3>
                        <p className="font-futura font-bold text-lg text-primary mb-1">
                          {t('registration:dates.may15.event')}
                        </p>
                        <p className="text-gray-600">{t('registration:dates.may15.detail')}</p>
                      </div>
                      <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-10 h-10 bg-primary rounded-full border-4 border-white shadow-lg"></div>
                      <div className="md:w-1/2 md:pl-12"></div>
                    </div>
                  </motion.div>

                  {/* June 5 */}
                  <motion.div {...fadeInUp} transition={{ delay: 0.3 }}>
                    <div className="md:flex md:items-center">
                      <div className="md:w-1/2 md:pr-12"></div>
                      <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-10 h-10 bg-primary rounded-full border-4 border-white shadow-lg"></div>
                      <div className="md:w-1/2 md:pl-12">
                        <h3 className="font-futura font-black text-2xl text-gray-900 mb-2">
                          {t('registration:dates.june5.date')}
                        </h3>
                        <p className="font-futura font-bold text-lg text-primary mb-1">
                          {t('registration:dates.june5.event')}
                        </p>
                        <p className="text-gray-600">{t('registration:dates.june5.detail')}</p>
                      </div>
                    </div>
                  </motion.div>

                  {/* June 6 - Race Day */}
                  <motion.div {...fadeInUp} transition={{ delay: 0.4 }}>
                    <div className="md:flex md:items-center">
                      <div className="md:w-1/2 md:pr-12 md:text-right mb-4 md:mb-0">
                        <h3 className="font-futura font-black text-3xl text-primary mb-2">
                          {t('registration:dates.june6.date')}
                        </h3>
                        <p className="font-futura font-black text-2xl text-gray-900 mb-1">
                          {t('registration:dates.june6.event')}
                        </p>
                        <p className="text-gray-600 font-bold">{t('registration:dates.june6.detail')}</p>
                      </div>
                      <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-16 h-16 bg-primary rounded-full border-4 border-white shadow-xl flex items-center justify-center">
                        <i className="ri-flag-line text-white text-2xl"></i>
                      </div>
                      <div className="md:w-1/2 md:pl-12"></div>
                    </div>
                  </motion.div>
                </div>
              </div>
            </div>
          </section>

          {/* What's Included */}
          <section className="py-24 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <motion.h2
                {...fadeInUp}
                className="font-futura font-black text-4xl sm:text-5xl text-primary text-center mb-16"
              >
                {t('registration:included.title')}
              </motion.h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {/* Bib */}
                <motion.div {...fadeInUp} transition={{ delay: 0.1 }} className="text-center p-6">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-gray-100 rounded-full">
                    <i className="ri-number-1 text-4xl text-primary"></i>
                  </div>
                  <h3 className="font-futura font-bold text-lg text-gray-900 mb-2">
                    {t('registration:included.bib.title')}
                  </h3>
                  <p className="text-gray-600 text-sm">{t('registration:included.bib.description')}</p>
                </motion.div>

                {/* Shirt */}
                <motion.div {...fadeInUp} transition={{ delay: 0.2 }} className="text-center p-6">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-gray-100 rounded-full">
                    <i className="ri-t-shirt-line text-4xl text-primary"></i>
                  </div>
                  <h3 className="font-futura font-bold text-lg text-gray-900 mb-2">
                    {t('registration:included.shirt.title')}
                  </h3>
                  <p className="text-gray-600 text-sm">{t('registration:included.shirt.description')}</p>
                </motion.div>

                {/* Marking */}
                <motion.div {...fadeInUp} transition={{ delay: 0.3 }} className="text-center p-6">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-gray-100 rounded-full">
                    <i className="ri-map-line text-4xl text-primary"></i>
                  </div>
                  <h3 className="font-futura font-bold text-lg text-gray-900 mb-2">
                    {t('registration:included.marking.title')}
                  </h3>
                  <p className="text-gray-600 text-sm">{t('registration:included.marking.description')}</p>
                </motion.div>

                {/* Aid */}
                <motion.div {...fadeInUp} transition={{ delay: 0.4 }} className="text-center p-6">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-gray-100 rounded-full">
                    <i className="ri-cup-line text-4xl text-primary"></i>
                  </div>
                  <h3 className="font-futura font-bold text-lg text-gray-900 mb-2">
                    {t('registration:included.aid.title')}
                  </h3>
                  <p className="text-gray-600 text-sm">{t('registration:included.aid.description')}</p>
                </motion.div>

                {/* Medal */}
                <motion.div {...fadeInUp} transition={{ delay: 0.5 }} className="text-center p-6">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-gray-100 rounded-full">
                    <i className="ri-medal-line text-4xl text-primary"></i>
                  </div>
                  <h3 className="font-futura font-bold text-lg text-gray-900 mb-2">
                    {t('registration:included.medal.title')}
                  </h3>
                  <p className="text-gray-600 text-sm">{t('registration:included.medal.description')}</p>
                </motion.div>

                {/* Meal */}
                <motion.div {...fadeInUp} transition={{ delay: 0.6 }} className="text-center p-6">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-gray-100 rounded-full">
                    <i className="ri-restaurant-line text-4xl text-primary"></i>
                  </div>
                  <h3 className="font-futura font-bold text-lg text-gray-900 mb-2">
                    {t('registration:included.meal.title')}
                  </h3>
                  <p className="text-gray-600 text-sm">{t('registration:included.meal.description')}</p>
                </motion.div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="relative py-24 overflow-hidden">
            {/* Background Image */}
            <div className="absolute inset-0">
              <img
                src="https://static.readdy.ai/image/0d2a8bbfaad65247a8e821bed673477a/164c209bd6716a531e2c0a8a6dfff3c3.jpeg"
                alt="Sinjavina Trail"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-primary/70"></div>
            </div>

            {/* Content */}
            <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
              <motion.h2
                {...fadeInUp}
                className="font-futura font-black text-4xl sm:text-5xl mb-10 text-white"
              >
                {t('registration:cta.title')}
              </motion.h2>
              <motion.a
                {...fadeInUp}
                transition={{ delay: 0.2 }}
                href="https://www.avaibooksports.com/inscripcion/sinjavina-skyrace/inscripcion_datos/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-white text-primary hover:bg-gray-100 font-futura font-bold text-lg px-12 py-4 rounded-full transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                {t('registration:cta.button')}
              </motion.a>
            </div>
          </section>
        </main>
      </div>
      <Footer />
    </>
  );
}